import { IconName } from '@core/user-interface-legacy';

import { pageIdToIconMapping } from './navigation-icon-mapping';

type NavigationIconPair = [inactive: IconName, active: IconName];

export function flipActiveIcon(icons: NavigationIconPair | null, isActive: boolean): string | null {
  if (icons) {
    const [inactive, active] = icons;
    return isActive ? active : inactive;
  }

  return null;
}

export function getNavItemIconPair(
  appKind: string | null,
  pageId: string | null,
): NavigationIconPair {
  const defaultIcon = 'error-outline';
  if (!pageId) return [defaultIcon, defaultIcon];

  const exact = pageIdToIconMapping[`${appKind}-${pageId}`] || pageIdToIconMapping[pageId];

  if (exact) return exact;

  if (pageId.includes(':')) {
    const pattern = `${pageId.split(':').shift()}:*`;
    const match = pageIdToIconMapping[pattern];

    if (match) {
      return match satisfies NavigationIconPair;
    }
  }

  // default icons if match not found
  console.warn(`[Tellent Navigation] No icon match for id: "${pageId}" (app: ${appKind})`);
  return ['tellent-nav-goals-inactive', 'tellent-nav-goals-active'];
}
